import type { RadarPoint } from '@/pages/analytics/types';

export interface RadarAxis {
  key: string;
  label: string;
}

const FALLBACK_RADAR_AXES: RadarAxis[] = [
  { key: 'compliance', label: 'Compliance' },
  { key: 'communication', label: 'Communication' },
  { key: 'content', label: 'Content' },
];

const FALLBACK_RADAR_LABELS = new Map(FALLBACK_RADAR_AXES.map(axis => [axis.key, axis.label]));

const formatSectionLabel = (key: string): string => {
  const label = key.trim().replace(/[-_]+/g, ' ').replace(/\s+/g, ' ');
  if (!label) return key;
  return `${label.charAt(0).toUpperCase()}${label.slice(1).toLowerCase()}`;
};

const radarAxisLabel = (key: string): string =>
  FALLBACK_RADAR_LABELS.get(key) ?? formatSectionLabel(key);

export const deriveRadarAxesFromPoints = (points: RadarPoint[]): RadarAxis[] => {
  const keys = new Set<string>();

  for (const point of points) {
    for (const key of Object.keys(point.categories ?? {})) {
      keys.add(key);
    }
  }

  if (!keys.size) return FALLBACK_RADAR_AXES;

  return [...keys].map(key => ({ key, label: radarAxisLabel(key) }));
};

export const hasRadarCurrentData = (points: RadarPoint[]): boolean =>
  points.some(point =>
    Object.values(point.categories ?? {}).some(value => Number.isFinite(value) && value > 0),
  );
